import React, { useState, useEffect, useCallback } from 'react';
import BuyerPortalLayout from '../../components/buyer/BuyerPortalLayout';
import { fetchVerifiedSuppliers } from '../../lib/buyerApi';

const BuyerSuppliersPage: React.FC = () => {
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchVerifiedSuppliers();
      setSuppliers(res.suppliers || res.items || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <BuyerPortalLayout title="Verified Suppliers">
      {loading ? (
        <div className="flex items-center justify-center py-16"><div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" /></div>
      ) : suppliers.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-2xl border border-gray-100">
          <p className="text-5xl mb-4">🏪</p>
          <h3 className="text-lg font-bold text-gray-900 mb-2">No verified suppliers yet</h3>
          <p className="text-gray-500 text-sm">Verified suppliers will appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {suppliers.map((s: any) => (
            <div key={s.id} className="bg-white border border-gray-100 rounded-2xl p-5 hover:shadow-md transition">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-xl flex items-center justify-center shrink-0">
                  {s.logo_url ? <img src={s.logo_url} alt="" className="w-full h-full object-cover rounded-xl" /> :
                    <span className="text-white text-lg font-bold">{(s.business_name || 'S')[0]}</span>}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <h3 className="font-bold text-gray-900 text-sm truncate">{s.business_name}</h3>
                    {s.verification_status === 'verified' && <span className="text-blue-500 text-xs">✓</span>}
                  </div>
                  <p className="text-xs text-gray-500 mt-0.5">{s.business_type || 'Agricultural Supplier'}</p>
                  {s.city && <p className="text-xs text-gray-400">{s.city}{s.country ? `, ${s.country}` : ''}</p>}
                </div>
              </div>
              {s.description && <p className="text-xs text-gray-500 mt-3 line-clamp-2">{s.description}</p>}
              <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
                <span className="text-xs text-gray-400">{(() => {
                  if (!s.products) return '';
                  try {
                    const parsed = typeof s.products === 'string' ? JSON.parse(s.products) : s.products;
                    if (Array.isArray(parsed)) return `${parsed.length} products`;
                    return '';
                  } catch {
                    // Comma-separated string like "avocado,banana"
                    const list = String(s.products).split(',').filter(Boolean);
                    return list.length > 0 ? `${list.length} products` : '';
                  }
                })()}</span>
                <span className="text-xs font-bold text-emerald-600">Verified</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </BuyerPortalLayout>
  );
};

export default BuyerSuppliersPage;
